import { Predicate } from '~/types/Predicate';

export const or =
  <T>(predicates: Predicate<T>[]) =>
  (x: T): boolean => {
    return predicates.reduce((bool: boolean, predicate: Predicate<T>) => {
      return bool || predicate(x);
    }, false);
  };
